import React from "react";
import { Link } from "react-router-dom";

export default function MenuItem({ name, linkTo }) {
    return (
        <li className="dropdown">
            <ul key={`menu-dropdown-item`}>
                <Link to={linkTo} className="py-2 px-2 block whitespace-no-wrap hover:text-pink-350 transition-all"> {name}</Link>
            </ul>
        </li>
    )
}